module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BoutiqueWalletView.js"));
	}, "BonusWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BonusWalletView!./src/pages/Shop/Member/Wallet/BoutiqueWallet/BoutiqueWalletView.js
// module id = 1044
// module chunks = 438